import { Component, Input } from '@angular/core';
import { CategoryColors } from '@jessie/commons';
import { NgClass } from '@angular/common';

export type BadgeColors =
  | 'grey'
  | 'red'
  | 'yellow'
  | 'green'
  | 'blue'
  | 'indigo'
  | 'purple'
  | 'pink';

export const allBadgeColors: CategoryColors[] = [
  'grey',
  'red',
  'yellow',
  'green',
  'blue',
  'indigo',
  'purple',
  'pink',
];

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  imports: [NgClass],
  styles: `
    @reference "tailwindcss";
    :host {
      @apply select-none;
    }
  `,
})
export class BadgeComponent {
  @Input() color: BadgeColors = 'grey';
  @Input() style: 'pill' | 'badge' = 'badge';
  @Input() size: 'small' | 'large' = 'small';
}
